<div class="pageWrapper scrollPanel"
  infiniteScroll
  [infiniteScrollDistance]="1"
  [infiniteScrollThrottle]="500"
  (scrolled)="onScrollPage()"
  [scrollWindow]="true"
>
  <div class="formsDetails rfq">
    <div class="sidebar"> 
      <div class="productCategory">
        <ul class="nav-list">
          <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: sidebarList, level: 1 }"></ng-container>
          <ng-template #recursiveList let-items let-level="level">
            <ng-container *ngFor="let item of items | sortByOrder: 'name'; trackBy: identify">
              <li
                *ngIf="item.parent_id"
                class="nav-item"
                [ngClass]="{
                  level_1: level == 1,
                  level_2: level == 2,
                  level_3: level == 3,
                  level_4: level == 4,
                  'leaf-node': !item.children.length
                }"
              >
                <span
                  (click)="getCategoryProduct(item.category_id, item.name, item.slug); setActive(item.category_id)"
                  [ngClass]="{ active: activeListItem == item.category_id }"
                >
                  {{ item.name }}
                  <!-- <small *ngIf="item.children.length">({{item.children.length}})</small> -->
                </span>
                <span (click)="toggleCollapse(item)" *ngIf="item.children && item.children.length" class="colloapseIco">
                  <ng-container *ngIf="isCollapsed(item); else elseTemplate">
                    <lucide-icon name="chevron-down" [size]="16" class="lucid-icon"></lucide-icon>
                  </ng-container>
                  <ng-template #elseTemplate>
                    <lucide-icon name="chevron-right" [size]="16" class="lucid-icon"></lucide-icon>
                  </ng-template>
                </span>
                <ul *ngIf="item.children && item.children.length" class="child-menu" [ngClass]="{ showMenu: isCollapsed(item) }">
                  <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: item.children, level: level + 1 }"></ng-container>
                </ul>
              </li>
            </ng-container>
          </ng-template>
        </ul>
      </div>
    </div> 
    <div class="product-list">
      <div class="bredcrumbWrp">
        <ul>
            <li *ngIf="parentCategoryName && parentCategoryId !==1" class="active"  (click)="getCategoryProduct(parentCategoryId, parentCategoryName)">
                {{parentCategoryName}}
            </li>
            <li>{{categoryName}}</li>
        </ul>
      </div>
      <h3 class="pageTitle">{{categoryName}}</h3>
      <div class="row">
        <div class="col-md-3 col-xs-6 pdb" *ngFor="let product of products">
          <div class="productItem">
            <div class="product-card" (click)="redirectProductDetail(product?.id)">
              <span class="product-image">
                <img src="{{product?.base_image?.original_image_url}}" alt="" srcset="" />
                <!-- <img style="background-image: url({{product?.base_image?.original_image_url}})" alt="" srcset="" /> -->
              </span>
              <!-- <span class="product-action"> </span> -->
              <h5 class="product-name" matTooltip="{{ product?.name }}">{{ product?.name }}</h5>
            </div>
            <!-- <h5 class="product-name" matTooltip="{{ product?.name }}">{{ product?.name }}</h5> -->
            <!-- <button mat-button class="product-btn" (click)="openDialog(product.name)">Add to Quote</button> -->
            <button mat-button class="product-btn" (click)="addToCart(product)">Add to Cart</button>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</div>
